import React from 'react';
import classes from './ResultBalls.module.scss';

const ResultBalls = ({ numbers, gap = 8 }) => (
  <div className={classes.Container} style={{ gap }}>
    {numbers.map((num, i) => (
      <div
        key={i}
        className={
          classes.Ball +
          ' ' +
          (num.type === 'BONUS' ? classes.Bonus : classes.Normal)
        }
      >
        <span className={classes.Text}>{num.value}</span>
      </div>
    ))}
  </div>
);

export default ResultBalls;
